import { createRouter, createWebHashHistory } from 'vue-router' // ✅ 使用 hash 模式

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', hidden: true }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      }
    ]
  },
  {
    path: '/product',
    component: () => import('@/layout/index.vue'),
    redirect: '/product/list',
    meta: { title: '产品管理', icon: 'Goods' },
    children: [
      {
        path: 'list',
        name: 'ProductList',
        component: () => import('@/views/product/index.vue'),
        meta: { title: '产品列表' }
      }
    ]
  },
  {
    path: '/technician',
    component: () => import('@/layout/index.vue'),
    redirect: '/technician/list',
    meta: { title: '技师管理', icon: 'User' },
    children: [
      {
        path: 'list',
        name: 'TechnicianList',
        component: () => import('@/views/technician/index.vue'),
        meta: { title: '技师列表' }
      }
    ]
  },
  {
    path: '/order',
    component: () => import('@/layout/index.vue'),
    redirect: '/order/list',
    meta: { title: '订单管理', icon: 'List' },
    children: [
      {
        path: 'list',
        name: 'OrderList',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单列表' }
      }
    ]
  },
  {
    path: '/appointment',
    component: () => import('@/layout/index.vue'),
    redirect: '/appointment/list',
    meta: { title: '预约管理', icon: 'Calendar' },
    children: [
      {
        path: 'list',
        name: 'AppointmentList',
        component: () => import('@/views/appointment/index.vue'),
        meta: { title: '预约列表' }
      }
    ]
  },
  {
    path: '/coupon',
    component: () => import('@/layout/index.vue'),
    redirect: '/coupon/list',
    meta: { title: '卡券管理', icon: 'Ticket' },
    children: [
      {
        path: 'list',
        name: 'CouponList',
        component: () => import('@/views/coupon/index.vue'),
        meta: { title: '卡券列表' }
      }
    ]
  },
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    meta: { hidden: true }
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
    meta: { hidden: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(), // ✅ 这里改为 hash 模式
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 小程序管理系统` : '小程序管理系统'

  // 判断是否登录
  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    if (token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router
